import { useContext } from "react";
import { TaskContext } from "../context/TaskContext";

const useSubTask = () => {
    const context = useContext(TaskContext);
    if (!context) throw new Error("useSubTask must be used within TaskContextContext");
    return context;
};

export default useSubTask;
